import { Component, OnInit, Input, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { MenuItem, DrawerComponent } from '@arc/aureus';

@Component({
  selector: 'app-system-drawer',
  templateUrl: './system-drawer.component.html',
  styleUrls: ['./system-drawer.component.scss']
})
export class SystemDrawerComponent implements OnInit {
  private _activeSection: MenuItem;

  @Input()
  settingSections: MenuItem[];
  @Input()
  public get activeSection(): MenuItem {
    return this._activeSection;
  }
  public set activeSection(value: MenuItem) {
    this._activeSection = value;
  }

  @Input()
  drawerDrawn = false;

  @ViewChildren(DrawerComponent)
  drawerList: QueryList<DrawerComponent>;

  constructor() { }

  ngOnInit() { }

  open(event: MouseEvent = null) {
    this.drawerDrawn = true;
    this.drawerList.first.open(event);
  }

  ssoSaved($event) {
    this.drawerDrawn = false;
    this.drawerList.first.close();
  }

  ssoCanceled($event) {
    this.drawerDrawn = false;
    this.drawerList.first.close();
  }

  visibleChange($event) {
    this.drawerDrawn = $event;
  }
}
